
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { LogoMarca } from '../components/MarcaCurriculo';

export default function SuccessScreen() {
  const navigate = useNavigate();
  return (
    <div style={{ textAlign: 'center', minHeight: '60vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
      <LogoMarca style={{ width: 120, marginBottom: 10 }} />
      <h2 style={{ color: '#28a745', fontWeight: 700, fontSize: 28, marginBottom: 8 }}>Sucesso!</h2>
      <p style={{ fontSize: 18, color: '#444', marginBottom: 18 }}>Seu currículo foi salvo e o PDF gerado.</p>
      <button className="btn btn-primary" style={{ fontSize: 16, padding: '10px 28px' }} onClick={() => navigate('/')}>Voltar ao Início</button>
    </div>
  );
}
